import React from 'react';

const Belarus = (props) => (
  <svg width="28" height="20" viewBox="0 0 28 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_3127_46724)">
      <rect width="28" height="20" rx="3" fill="#F93939" />
      <path
        d="M25.3333 0H2.66667C1.19391 0 0 1.19391 0 2.66667V17.3333C0 18.8061 1.19391 20 2.66667 20H25.3333C26.8061 20 28 18.8061 28 17.3333V2.66667C28 1.19391 26.8061 0 25.3333 0Z"
        fill="#F93939"
      />
      <path fillRule="evenodd" clipRule="evenodd" d="M6.6665 14.6665H27.9998V19.9998H6.6665V14.6665Z" fill="#249F58" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 0L6.66667 2L4 4V0ZM4 4L6.66667 6L4 8V4ZM4 8L6.66667 10L4 12V8ZM4 12L6.66667 14L4 16V12ZM4 16L6.66667 18L4 20V16ZM2.66667 0L0 2L2.66667 4V0ZM2.66667 4L0 6L2.66667 8V4ZM2.66667 8L0 10L2.66667 12V8ZM2.66667 12L0 14L2.66667 16V12ZM2.66667 16L0 18L2.66667 20V16ZM2.66667 0H4V2.66667H2.66667V0ZM2.66667 17.3333H4V20H2.66667V17.3333ZM2.66667 6.66667H4V9.33333H2.66667V6.66667ZM2.66667 4H4V5.33333H2.66667V4ZM2.66667 14.6667H4V16H2.66667V14.6667ZM2.66667 10.6667H4V13.3333H2.66667V10.6667Z"
        fill="white"
      />
    </g>
    <rect x="0.25" y="0.25" width="27.5" height="19.5" rx="2.75" stroke="#AEAEAE" strokeWidth="0.5" />
    <defs>
      <clipPath id="clip0_3127_46724">
        <rect width="28" height="20" rx="3" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default Belarus;
